var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.63888H2.66667M2.66667 4.63888H16M2.66667 4.63888V16.3055C2.66667 16.7476 2.84226 17.1715 3.15482 17.4841C3.46738 17.7966 3.89131 17.9722 4.33333 17.9722H12.6667C13.1087 17.9722 13.5326 17.7966 13.8452 17.4841C14.1577 17.1715 14.3333 16.7476 14.3333 16.3055V4.63888H2.66667ZM5.16667 4.63888V2.97221C5.16667 2.53018 5.34226 2.10626 5.65482 1.7937C5.96738 1.48114 6.39131 1.30554 6.83333 1.30554H10.1667C10.6087 1.30554 11.0326 1.48114 11.3452 1.7937C11.6577 2.10626 11.8333 2.53018 11.8333 2.97221V4.63888M6.83333 8.80554V13.8055M10.1667 8.80554V13.8055",
    stroke: "#024E7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.bb6189756f72aa8d075d554b2c2bef55.svg";
export { ForwardRef as ReactComponent };